import { createStore, applyMiddleware } from "redux";
import logger from "redux-logger";
import {rootReducer} from "./reducer";

const middleware = [];

if(process.env.REACT_APP_DEVELOPE_MODE === "true"){
  middleware.push(logger)
}

const Store = createStore(rootReducer, applyMiddleware(...middleware));

export default Store;